import { RegExpUtility } from "../../../library-js/text/RegExpUtility";
import { BinaryByteUnitConverter } from "../../../library-js/units/BinaryByteUnitConverter"
import { BinaryByteUnitPrefix } from "../../../library-js/units/BinaryByteUnitPrefix"
import { SIUnitConverter } from "../../../library-js/units/SIUnitConverter"
import { SIUnitPrefix } from "../../../library-js/units/SIUnitPrefix"
import { MathX } from "../../../library-js/math/MathX";

export class Result
{
  numMaterials:number = 0;
  sizeAllGiB:string = "";
  materialSizeMB:string = "";
}


export function computeAvailableNumberOfTextures( element:Element )
{
  let getIntValue = ( name:string )=>
  {
    let stringValue = ( element.querySelector( "#" + name ) as HTMLInputElement ).value;

    let startingDigits = /^\s*(\d+)/.exec( stringValue );

    console.log( "GET INT:", stringValue,  startingDigits );

    if ( startingDigits )
    {
      stringValue = startingDigits[ 1 ];
    }

    let value = parseInt( stringValue )
    return value;
  }


  let size     = getIntValue( "size" );
  let channels = getIntValue( "channels" );
  let ram      = getIntValue( "ram" );

  let bytesTexture = size * size * channels;
  let ramInBytes   = BinaryByteUnitConverter.convert( ram, BinaryByteUnitPrefix.giga, BinaryByteUnitPrefix.base );

  console.log( { bytesTexture, ramInBytes } );

  let result = new Result();
  result.numMaterials = Math.floor( ramInBytes / bytesTexture );
  result.materialSizeMB = MathX.stringify( SIUnitConverter.fromBase( bytesTexture, SIUnitPrefix.mega ) );
  result.sizeAllGiB = MathX.stringify( BinaryByteUnitConverter.fromBase( bytesTexture * result.numMaterials, BinaryByteUnitPrefix.giga ) );

  return result;
}